module.exports = __webpack_public_path__ + "static/shadows@2x-fb60b03c9c19601ac0fd6c078a9179ea.png";